module.exports = __webpack_public_path__ + "static/media/pay-option.e4cb4525.svg";